module.exports = __webpack_public_path__ + "img/login-bg.ecde9eb2.png";